import { defineMessages, useIntl } from 'react-intl';

import { TwcSpotlightCard } from './TwcSpotlightCard';

import { buttonMessages } from './button-messages';

import { SWITCHER_SPOTLIGHT_NUMBER } from './constants';

import SwitcherIllustrationDark from '../../assets/Switcher-Illustration-Dark.png';

import SwitcherIllustrationLight from '../../assets/Switcher-Illustration-Light.png';

import { type JSX } from 'react/jsx-runtime';

type SwitcherSpotlightProps = {
	spotlightEnd: () => void;
	spotlightNext: () => void;
	spotlightBack: () => void;
	numTotalSpotlights: number;
};

export const SwitcherSpotlight = (props: SwitcherSpotlightProps): JSX.Element => {
	const { spotlightEnd, spotlightNext, spotlightBack, numTotalSpotlights } = props;

	const intl = useIntl();
	return (
		<TwcSpotlightCard
			testId="switcher-spotlight"
			heading={intl.formatMessage(messages.heading)}
			body={intl.formatMessage(messages.body)}
			lightSrcImage={SwitcherIllustrationLight}
			darkSrcImage={SwitcherIllustrationDark}
			primaryInteraction={numTotalSpotlights === 3 ? 'next' : 'acknowledged'}
			primaryActionFunction={numTotalSpotlights === 3 ? spotlightNext : spotlightEnd}
			primaryActionText={
				numTotalSpotlights === 3
					? intl.formatMessage(buttonMessages.spotlightNextButton)
					: intl.formatMessage(buttonMessages.spotlightOkButton)
			}
			secondaryActionFunction={spotlightBack}
			secondaryActionText={intl.formatMessage(buttonMessages.spotlightBackButton)}
			spotlightEnd={spotlightEnd}
			currentSpotlightNumber={SWITCHER_SPOTLIGHT_NUMBER}
			numTotalSpotlights={numTotalSpotlights}
			spotlightType="switcher"
		/>
	);
};

const messages = defineMessages({
	heading: {
		defaultMessage: 'Find all your apps here',
		description: 'Heading for team work collection onboarding tour spotlight for the app switcher',
		id: 'townsquare.twc-onboarding-modal.app-switcher.heading',
	},
	body: {
		defaultMessage: 'Use this menu to easily switch between other Atlassian apps.',
		description: 'Body for team work collection onboarding tour spotlight for the app switcher',
		id: 'townsquare.twc-onboarding-modal.app-switcher.body',
	},
});
